import { useState } from 'react';

import { Container } from '../../../../components/Container/Container';
import { ISEOWaterWithTypeList, WaterType } from '../../../../constants/fishingWaters/constants';

import { Tab } from './components/Tab';
import { WaterLinks } from './components/WaterLinks';

interface IProps {
  top20riversInUS: ISEOWaterWithTypeList;
  top20oceansInUS: ISEOWaterWithTypeList;
  top20lakesInUS: ISEOWaterWithTypeList;
}

export const TopUSWatersByWaterType = ({
  top20riversInUS,
  top20oceansInUS,
  top20lakesInUS,
}: IProps) => {
  const [selectedWaterType, setSelectedWaterType] = useState<WaterType>('ocean');
  return (
    <Container className="-px-6 sm:-px-11 md:-px-14">
      <div className="p-4">
        <div className="rounded-lg p-4">
          <div>
            <Tab
              buttonText="Ocean waters"
              onClick={() => {
                setSelectedWaterType('ocean');
              }}
              className={`w-1/3 ${selectedWaterType === 'ocean' ? 'bg-sea-foam' : 'bg-twilight'}`}
            />
            <Tab
              buttonText="Lakes / Ponds"
              onClick={() => {
                setSelectedWaterType('lake');
              }}
              className={`w-1/3 ${selectedWaterType === 'lake' ? 'bg-sea-foam' : 'bg-twilight'}`}
            />
            <Tab
              buttonText="Rivers / Streams"
              onClick={() => {
                setSelectedWaterType('river');
              }}
              className={`w-1/3 ${selectedWaterType === 'river' ? 'bg-sea-foam' : 'bg-twilight'}`}
            />
          </div>

          <WaterLinks
            waters={top20riversInUS}
            selectedWaterType={selectedWaterType}
            thisWaterType="river"
          />
          <WaterLinks
            waters={top20oceansInUS}
            selectedWaterType={selectedWaterType}
            thisWaterType="ocean"
          />
          <WaterLinks
            waters={top20lakesInUS}
            selectedWaterType={selectedWaterType}
            thisWaterType="lake"
          />
        </div>
      </div>
    </Container>
  );
};
